import { track, updatePageProps } from '@eventbrite/datalayer-library';
import { getWindowObject } from '@eventbrite/feature-detection';
import { LOCATION_CHANGE } from 'react-router-redux';
import { AnyAction, Dispatch, Store } from 'redux';
import { actionTypes } from 'redux-form';
import { getEventId, getIsFreeEvent } from '../selectors/event';
import {
    getIsNosSourceOfTruth,
    getOrderPersistentId,
} from '../selectors/order';
import { getSelectedPaymentMethod } from '../selectors/payment';
import { CheckoutState } from '../state';
import {
    DATALAYER_MIDDLEWARE_CHECKOUT_SUBMIT_EVENT_NAME,
    DATALAYER_MIDDLEWARE_LOCATION_CHANGE_EVENT_NAME,
} from './constants';

export const dataLayerMiddleware =
    (store: Store<CheckoutState>) =>
    (next: Dispatch<CheckoutState>) =>
    (action: AnyAction) => {
        const state = store?.getState();
        const orderId = getOrderPersistentId(state);
        const eventId = getEventId(state);
        const isNOS = getIsNosSourceOfTruth(state);
        const isFree = getIsFreeEvent(state);
        const selectedPaymentMethod = getSelectedPaymentMethod(state);
        const { type, payload } = action;
        const location = getWindowObject('location');

        // This tracks form submits, i.e. passing from one step to another
        if (type == actionTypes.START_SUBMIT && action.meta?.form) {
            track({
                eventName: DATALAYER_MIDDLEWARE_CHECKOUT_SUBMIT_EVENT_NAME,
                eventData: { form: action.meta.form },
            });
        }

        // This enriches all following events with all the data we're interested in
        if (
            type == LOCATION_CHANGE &&
            payload?.pathname &&
            payload.pathname !== '/' &&
            location
        ) {
            const destinationURL = location.origin + payload.pathname;

            const page = {
                destinationURL,
                routerPayload: payload,
                isNOS,
                ...(orderId && { orderId }),
                ...(eventId && { eventId }),
                ...(typeof isFree === 'boolean' && { isFree }),
                ...(selectedPaymentMethod && { selectedPaymentMethod }),
            };

            updatePageProps({
                page,
                eventName: DATALAYER_MIDDLEWARE_LOCATION_CHANGE_EVENT_NAME,
            });
        }

        return next(action);
    };
